(function() {
    const link = document.getElementById('see-wallpaper-info')
    const bubble = document.getElementById('wallpaper-bubble')
    if (!link || !bubble) return
    const bubbleTextSpan = bubble.querySelector('.bubble-text')
    const closeButton = bubble.querySelector('.bubble-close')

    function hideBubble() {
        if (bubble) bubble.style.display = 'none'
    }

    function showBubble(message: string, targetElement: Element) {
        if (bubbleTextSpan) bubbleTextSpan.textContent = message
        if (!bubble) return
        bubble.style.display = 'flex'
        bubble.style.visibility = 'hidden'
        bubble.style.position = 'fixed'

        const rect = targetElement.getBoundingClientRect()
        const bubbleRect = bubble.getBoundingClientRect()

        // Calculate position (default: top)
        let top = rect.top - bubbleRect.height - 8;
        let left = rect.left + (rect.width / 2) - (bubbleRect.width / 2);

        if (top < 8) { // No space on top, display at bottom
            top = rect.bottom + 8;
        }
        if (left < 8) left = 8;
        if (left + bubbleRect.width > window.innerWidth - 8) {
            left = window.innerWidth - bubbleRect.width - 8;
        }

        bubble.style.top = `${top}px`;
        bubble.style.left = `${left}px`;
        bubble.style.visibility = 'visible';
    }

    closeButton?.addEventListener('click', e => {
        e.preventDefault()
        hideBubble()
    })

    link.addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()

        try {
            const cacheStr = localStorage.getItem('wallpaper_cache_v1');
            if (!cacheStr) {
                showBubble('📭 未找到壁纸信息，请稍后刷新重试', link);
                return;
            }
            const wallpaperData = JSON.parse(cacheStr);
            const copyright = wallpaperData.copyright;
            if (copyright && typeof copyright === 'string') {
                showBubble(copyright, link);
            } else {
                showBubble('⚠️ 当前壁纸无版权描述信息', link);
            }
        } catch (err) {
            console.warn('读取壁纸缓存失败', err);
            showBubble('❌ 读取壁纸信息失败', link);
        }
    })

    // Click elsewhere to hide
    document.addEventListener('click', function(e) {
        if (e.target instanceof Node && !bubble.contains(e.target) && !link.contains(e.target)) {
            hideBubble();
        }
    });
})()